(() => {
  const init = root => {
    if (!root || root.dataset.llrReady) return;
    root.dataset.llrReady = 'true';
    const body = root.querySelector('[data-llr-body]');
    body.querySelectorAll('h2,h3,h4,h5,h6,p').forEach(el => {
      if (!el.textContent.replace(/\u00a0/g, ' ').trim() && !el.querySelector('img,iframe,video,audio,svg,table,input')) el.remove();
    });
    body.querySelectorAll('img').forEach((img, index) => {
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
      if (!img.hasAttribute('loading')) img.loading = index === 0 && !root.querySelector('.bf-llr__hero') ? 'eager' : 'lazy';
      img.decoding = 'async';
    });
    body.querySelectorAll('iframe').forEach(frame => {
      if (!frame.title) frame.title = root.querySelector('h1').textContent;
      frame.loading = 'lazy';
    });
    const share = root.querySelector('[data-llr-share]');
    if (share && navigator.clipboard && window.isSecureContext) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(share.dataset.url);
          root.querySelector('[data-llr-status]').textContent = share.dataset.copied;
        } catch (_) {
          share.hidden = true;
        }
      });
    }
  };
  document.querySelectorAll('[data-llr-article]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-llr-article]').forEach(init));
})();
